<template>
  <div>

    <div class="stepsdemo-content">
      <div class="card card-theme">
        <h3 class="card-title">
          Confirmation
        </h3>
        <h6 class="card-subtitle">
          Please press the Submit button to add the charity
        </h6>
        <div class="client-card-footer">
          <div class="client-card-footer">
            <div class="p-grid p-nogutter p-justify-between">
<!--              <Button label="Back to List" @click="backToList()" icon="pi pi-angle-left" class="p-button-secondary"-->
<!--                      v-if="backListVisibility"/>-->
              <Button label="Back" @click="prevPage()" icon="pi pi-angle-left"/>
              <Button
                      label="Submit" @click="complete()" icon="pi pi-check" iconPos="right" class="p-button-success"
                      v-if="submitVisibility && user_accesses && userService.hasAccess(user_accesses, ['admin', 'edit_client', 'add_client'])"/>
            </div>
          </div>
        </div>
      </div>
    </div>

  </div>
</template>

<script>
  import UserService from '../../services/UserService';

  export default {
    data() {
      return {
        submitted: false,
        backListVisibility: false,
        backVisibility: true,
        submitVisibility: true,
        user_accesses: this.$store.state.accesses
      }
    },
    userService: null,
    created() {
      this.userService = new UserService();
    },
    methods: {
      complete() {
        this.backListVisibility = true;
        this.$emit('complete');
      },
      prevPage() {
        this.$emit('prevPage', {pageIndex: 2});
      },
      backToList() {
        this.$router.push('/charities').catch()
      }
    }
  }
</script>

<style scoped>
  .card-subtitle {
    margin: 0;
    margin-bottom: 3em;
  }

  .card-title {
    margin-bottom: 0.5em;
    font-weight: bold;
  }

  .card-input {
    width: 100%;
    margin-bottom: 1rem;
  }
</style>